import * as demoBrand from "./productsBundles/demoBrand";
import * as defaultMockNo from "./productsBundles/defaultNo";
import * as devBrand from "./productsBundles/devBrand";
import * as devAllOrdersBrand from "./productsBundles/devAllOrdersBrand";
import * as defaultNoRefundOptions from "./productsBundles/defaultNoRefundOptions";
import * as onlyOne from "./productsBundles/onlyOne";
import * as kids from "./productsBundles/kids";
import * as shoes from "./productsBundles/shoes";
import * as aimn from "./productsBundles/aimn";
import * as astridWild from "./productsBundles/astridWild";
import * as eytys from "./productsBundles/eytys";
import * as cdlp from "./productsBundles/cdlp";
import * as weekday from "./productsBundles/weekday";
import * as patagonia from "./productsBundles/patagonia";
import * as singular from "./productsBundles/singular";
import * as komplett from "./productsBundles/komplett";
import * as lexington from "./productsBundles/lexington";
import * as oddmolly from "./productsBundles/oddmolly";
import * as norrona from "./productsBundles/norrona";
import * as newbie from "./productsBundles/newbie";
import * as asket from "./productsBundles/asket";
import * as otherstories from "./productsBundles/otherstories";
import * as hm from "./productsBundles/hm";
import * as pauseInvoice from "./productsBundles/pauseInvoice";
import * as axelArigato from "./productsBundles/axel arigato";
import * as axelArigatoResale from "./productsBundles/axel arigato resale";
import * as jLindeberg from "./productsBundles/jLindeberg";
import * as houdini from "./productsBundles/houdini";
import * as ahlvarGallery from "./productsBundles/ahlvarGallery";
import * as mayaDolores from "./productsBundles/mayaDolores";
import * as djerfAvenue from "./productsBundles/djerfAvenue";
import * as cos from "./productsBundles/cos";
import * as fashionInStore from "./productsBundles/fashionInStore";
import * as gbpFashion from "./productsBundles/gbpFashion";
import * as ahlens from "./productsBundles/ahlens";
import * as algaEur from "./productsBundles/algaEur";
import * as algaGbp from "./productsBundles/algaGbp";
import * as algaUsd from "./productsBundles/algaUsd";
import * as algaSek from "./productsBundles/algaSek";
import * as algaEurNL from "./productsBundles/algaEurNL";
import * as rituals from "./productsBundles/rituals";
import * as rapunzel from "./productsBundles/rapunzel";

export let productsBundleMocks = {
    DEMO_BRAND: demoBrand,
    DEV_BRAND: devBrand,
    DEV_ALL_ORDERS_BRAND: devAllOrdersBrand,
    DEFAULT_NO: defaultMockNo,
    NO_REFUND_OPTIONS: defaultNoRefundOptions,
    ONLY_ONE: onlyOne,
    KIDS: kids,
    SHOES: shoes,
    AIMN: aimn,
    ASTRIDWILD: astridWild,
    EYTYS: eytys,
    CDLP: cdlp,
    WEEKDAY: weekday,
    SINGULAR: singular,
    PATAGONIA: patagonia,
    NORRONA: norrona,
    KOMPLETT: komplett,
    LEXINGTON: lexington,
    ODDMOLLY: oddmolly,
    NEWBIE: newbie,
    ASKET: asket,
    OTHER_STORIES: otherstories,
    HM: hm,
    PAUSE_INVOICE: pauseInvoice,
    AXEL_ARIGATO: axelArigato,
    AXEL_ARIGATO_RESALE: axelArigatoResale,
    J_LINDEBERG: jLindeberg,
    HOUDINI: houdini,
    AHLVAR_GALLERY: ahlvarGallery,
    MAYA_DOLORES: mayaDolores,
    DJERF_AVENUE: djerfAvenue,
    COS: cos,
    FASHION_IN_STORE: fashionInStore,
    FASHION_IN_STORE_GBP: gbpFashion,
    AHLENS: ahlens,
    ALGA_EUR: algaEur,
    ALGA_GBP: algaGbp,
    ALGA_USD: algaUsd,
    ALGA_SEK: algaSek,
    ALGA_EUR_NL: algaEurNL,
    RITUALS: rituals,
    RAPUNZEL: rapunzel,
};

export default function getMock({ productsBundleMock }) {
    return productsBundleMocks[productsBundleMock] || demoBrand;
}
